/**
 * Catálogo manual de permisos y grupos usados en la SPA.
 * Los permisos efectivos vienen del backend en /auth/me/; aquí definimos
 * constantes para no hardcodear strings sueltos en componentes.
 *
 * Asignación en Django: grupos/usuarios deben tener el permiso
 * `simulation.manage_deviation_categories` (alias API: deviation_categories.manage).
 */

/** Nombres de grupos de negocio conocidos (auth.Group.name). */
export const AUTH_GROUPS = {
  PROCURA: "Procura",
} as const;

/** Permisos expuestos por /auth/me/ (incluye alias). */
export const AUTH_PERMISSIONS = {
  /** Categorías de desviación (catálogo DeviationNote). */
  DEVIATION_CATEGORIES_MANAGE: "deviation_categories.manage",
} as const;
